/**
 * @format
 * @flow
 */
import DateJp from 'UltraDate.js';

DateJp.setDefaultLocale('ja');

class GenerateCalendarHash {
  constructor(day) {
    this.today = day || new DateJp();
    this.thisYear = this.today.getFullYear();
    this.upperYear = this.thisYear + 1;
    this.bottomYear = this.thisYear;
  }

  // setDate = () => {
  //   this.today = day || new DateJp()
  //   this.thisYear = this.today.getFullYear()
  //   this.upperYear = this.thisYear - 15
  //   this.bottomYear = this.thisYear - 100
  // }

  generateYears = () => {
    const array = [];
    for (let i = this.bottomYear; i <= this.upperYear; i++) {
      const hash = {};
      hash.label = `${i}年`;
      hash.value = i;
      hash.key = i;
      array.push(hash);
    }
    return array;
  };

  generateMonths = () => {
    const array = [];
    for (let i = 1; i <= 12; i++) {
      const hash = {};
      hash.label = `${i}月`;
      hash.value = `0${i}`.slice(-2);
      hash.key = i;
      array.push(hash);
    }
    return array;
  };

  generateDays = () => {
    const array = [];
    for (let i = 1; i <= 31; i++) {
      const hash = {};
      hash.label = `${i}日`;
      hash.value = `0${i}`.slice(-2);
      hash.key = i;
      array.push(hash);
    }
    return array;
  };

  generateHours = () => {
    const array = [];
    for (let i = 1; i <= 24; i++) {
      const hash = {};
      hash.label = `${i}時`;
      hash.value = `0${i}`.slice(-2);
      hash.key = i;
      array.push(hash);
    }
    return array;
  };

  generateDaysForSetting = () => {
    const array = [];
    for (let i = 1; i <= 28; i++) {
      const hash = {};
      hash.label = `${i}日`;
      hash.value = `0${i}`.slice(-2);
      hash.key = i;
      array.push(hash);
    }
    return array;
  };

  generateMinutes = () => {
    const array = [];
    for (let i = 0; i <= 45; i += 15) {
      const hash = {};
      hash.label = `${i}分`;
      hash.value = `0${i}`.slice(-2);
      hash.key = i;
      array.push(hash);
    }
    return array;
  };

  generateWeekItems = (limit = 7) => {
    const array = [];
    let day = new DateJp(); // this.today
    for (let i = 1; i <= limit; i++) {
      const hash = {};
      const dayInt = day.getISODay();
      hash.dayOfTheWeek = ['月', '火', '水', '木', '金', '土', '日'][i - 1];
      hash.isHoliday = day.isHoliday();
      hash.date = day.getDate();
      hash.month = day.getRealMonth();
      hash.year = day.getFullYear();
      hash.searchDate = day.format('yyyy/MM/dd');
      hash.dayInt = i === 7 ? 0 : i;
      array.push(hash);
      day = day.addDate(1);
    }
    console.log('TCL: GenerateCalendarHash -> generateWeekItems -> array', array);
    return array;
  };

  generateYearAndMonth = (start = new DateJp(2019, 4, 1)) => {
    const current = new DateJp();
    const currentYear = current.getFullYear();
    const currentMonth = current.getRealMonth();
    const startYear = start.getFullYear();
    const startMonth = start.getRealMonth();
    const diffYear = currentYear - startYear;

    let diffMonth;
    if (diffYear === 0) {
      diffMonth = currentMonth - startMonth + 2;
    } else {
      diffMonth = currentMonth + diffYear * 12 - startMonth + 2;
    }

    const array = [];

    for (let i = 1; i <= diffMonth; i++) {
      const hash = {};
      hash.key = start.format('yyyy/MM');
      hash.value = start.format('yyyy/MM');

      array.push(hash);
      start = start.addMonth(1);
    }

    return array;
  };
}

export default new GenerateCalendarHash();
